import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import GeneratePdf from "./../generatePdf/GeneratePdf";
import DownloadBarcode from "./../barcodePdf/DownloadBarCode.js";
import DownloadOrderExcel from "./../downloadOrderExcel/DownloadOrderExcel";

const DownloadOrder = (props) => {
  console.log("Open Download Order page");
  const orderData = props.order;
  const isLoading = !orderData;
  const showData = orderData;
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      scroll={"paper"}
      maxWidth={"lg"}
      fullWidth={true}
    >
      <div className={styles.container}>
        <div className={styles.containerContent}>
          <div className={styles.header}>
            <h1>Download Order</h1>
            <IconButton onClick={props.onClose}>
              <CloseRoundedIcon />
            </IconButton>
          </div>

          {showData == "NO_DATA" && (
            <div className={styles.emptyList}>
              <p>No data</p>
            </div>
          )}

          {showData && showData != "NO_DATA" && (
            <div className={styles.content}>
              <h2></h2>
              <DownloadBarcode order={props.order} />
              <GeneratePdf order={props.order} />
              <DownloadOrderExcel order={props.order} />
            </div>
          )}
          {isLoading && (
            <div className={styles.loader}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DownloadOrder;
